/* eslint-disable */
export enum RootPages {
  def="/",
  login="/login", // If this is changed to not include the / hard navigate to login function needs to be updated
  userInformations="/userInformations",
  error="/error",
}

export enum GlobalMenu_Pages {
  home="./",

  dashboard = "dashboard",

  kpi = "kpi",

  feedCurves = "feed curves",
  components = "components",
  componentsAlternatives = "component alternatives",
  mixtures = "mixtures",
  feedCurve = "feed curve",

  silos = "silos",
  silosSettings = "silo settings",

  animals = "animals",
  animalsGroups = "animal groups",
  animal = "animal",

  reports="reports",
  report="report",
  archive="archive",

  logbook="logbook",
  
  globalSettings="globalsettings",
  devices="devices"
}

export enum SystemMenu_Pages {
  home="./",

  autopig="autopig",
  Autopig_settings="settings",

  freeda_lf="lf",
  freeda_lf_sections="lf sections",
  // freeda_lf_section="section",
  freeda_lf_settings = "lf settings",
  
  freeda_esf = "esf",
  freeda_esf_sections = "esf sections",
  freeda_esf_settings = "esf settings"
}

export enum focus_viewMenu_Pages {
  home="./",
  op_operations="op_operations",
  op_animals = "op_animals",
  op_quickEntry = "op_quickentry",
  op_freeda_lf = "op_freeda_lf",
}

export enum ToolsMenu_Pages {
  home = "./",

  aico = "aico",
  log = "log",
  
  config = "config",

  firmware = "firmware",
  firmwareIO = "firmwareIO",

  deviceDataTables = "device-data-tables",
  terminal = "terminals",
  feedDay = "feed-days",
  feedTime = "feed-times",
  device = "devices",
  feedCurve = "feed-curves",
  system = "system",
  queue = "queue",
  actions = "actions",

  companies = "companies",
  createCompany = "create-company",

  users = "users",

  graphQL = "graphQL"
}
/* eslint-enable */